import { render, staticRenderFns } from "./NFCE.vue?vue&type=template&id=2731dad5"
import script from "./NFCE.vue?vue&type=script&lang=js"
export * from "./NFCE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports